import {refreshDmsDatagrid} from '@dms/shared';

import {TASK_GRID_CODE} from './TASK_GRID_CODE';

export const refreshTaskGrid = () => refreshDmsDatagrid(TASK_GRID_CODE);
